import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo.png';
import _imports_1 from '@/assets/icon-national.png';
const _hoisted_1 = {
  class: "header_module menu flex"
};
const _hoisted_2 = {
  class: "menu_list flex"
};
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { setTitle } from '@/utils/jsUnit';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    let mainDom = ref({});
    setTitle('鑫焱科技');
    const isScroll = ref(false);
    const handleScroll = event => {
      // 获取滚动位置
      const scrollTop = event.target.scrollTop;
      // 处理滚动逻辑
      // console.log('滚动位置:', scrollTop)
      isScroll.value = scrollTop > 100;
    };
    const router = useRouter();
    // const setFontSize = () => {
    //   const docEl = document.documentElement
    //   let clientWidth = docEl.clientWidth || window.innerWidth
    //   console.log(clientWidth, 'clientWidth')
    //   if (!clientWidth) return
    //   if (clientWidth < 1000) {
    //     router.replace({
    //       path: '/h5'
    //     })
    //   }
    //   if (clientWidth > 1000) {
    //     router.replace({
    //       path: '/'
    //     })
    //   }
    // }
    const handleMenu = url => {
      router.push({
        path: url
      });
    };
    const toMiit = () => {
      window.open('https://beian.miit.gov.cn', '_blank');
    };
    // 在组件挂载时执行
    onMounted(() => {
      // setFontSize()
      // window.addEventListener('resize', setFontSize)
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "mainDom",
        ref: mainDom,
        class: "app",
        onScroll: handleScroll
      }, [_createElementVNode("div", {
        class: _normalizeClass([isScroll.value ? 'header_scroll' : '', "header"])
      }, [_createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "logo_section"
      }, [_createElementVNode("img", {
        class: "logo",
        src: _imports_0,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "menu_item",
        onClick: _cache[0] || (_cache[0] = $event => handleMenu('/'))
      }, "首页"), _createElementVNode("div", {
        class: "menu_item",
        onClick: _cache[1] || (_cache[1] = $event => handleMenu('/scheme'))
      }, "解决方案"), _createElementVNode("div", {
        class: "menu_item",
        onClick: _cache[2] || (_cache[2] = $event => handleMenu('/culture'))
      }, "企业文化"), _createElementVNode("div", {
        class: "menu_item",
        onClick: _cache[3] || (_cache[3] = $event => handleMenu('/about'))
      }, "关于我们")])])], 2), _createVNode(_component_router_view), _createElementVNode("div", {
        class: "footer"
      }, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "tip"
      }, " 公司地址：浙江省杭州市西湖区文一西路830号B2-609室 | 商务合作：caiwu@niuguwang.com ", -1)), _createElementVNode("div", {
        class: "record flex"
      }, [_createElementVNode("div", {
        onClick: toMiit
      }, "浙ICP备2022024741号-1"), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "national flex"
      }, [_createElementVNode("img", {
        class: "icon_national",
        src: _imports_1,
        alt: ""
      }), _createElementVNode("div", null, "浙公网安备33010602013985号")], -1))])])], 544);
    };
  }
});